/**
 * Avis d'estoc de la `<legend>` del selector de talles.
 *
 * El text depen de dues coses: de quantes unitats queden de la variant que
 * s'esta mirant, i de si el boto d'avis de reposicio (app STOQ / Restock
 * Rocket) hi sortira quan s'esgoti.
 *
 *                     | "Nunca mostrar"     | "Cuando este agotado"
 *   poc estoc (1-4)   | se acabaron         | quedan pocas unidades
 *   esgotat (0)       | --                  | --
 *
 * Si el client no podra apuntar-se a cap avis, el missatge es definitiu; si si
 * que podra, es mes suau. Quan ja esta esgotat no cal dir res: ho diu la
 * pastilla de la talla (lila "avisa'm" o vermella "FIN", variant-picker.liquid).
 *
 * PER QUE EN JS I NO NOMES EN LIQUID. L'estat es de la VARIANT COMBINADA
 * (talla + color + estil), no de la talla: a "XL / Regular" i "XL / Extralargo"
 * l'estoc pot ser diferent, i Liquid nomes resol `value.variant` per a la
 * primera opcio. El Liquid, doncs, publica un mapa de totes les variants a
 * `[data-hb-stock-data]` i aqui es tria la que toca a cada canvi de seleccio.
 *
 * Els textos venen en `data-*` al propi `<span>`: les traduccions es resolen
 * al Liquid amb el filtre `t`, no aqui.
 */
(function () {
  'use strict';

  var LOW_STOCK_MAX = 5;

  function readStockData(picker) {
    var el = picker.querySelector('[data-hb-stock-data]');
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /**
   * La variant seleccionada. El `<select name="id">` del formulari es la font
   * fiable: el tema l'actualitza a cada canvi, tambe quan reemplaça el HTML
   * del selector.
   */
  function selectedVariantId(picker) {
    var form = picker.closest('form') || document;
    var input = form.querySelector('[name="id"]');
    if (input && input.value) return input.value;

    // Sense formulari (fitxa destacada, per exemple): la variant de l'input
    // de talla que estigui marcat.
    var checked = picker.querySelector('.js-option:checked[data-variant-id]');
    return checked ? checked.getAttribute('data-variant-id') : null;
  }

  /**
   * El text que toca i l'estat que el descriu. L'estat va a `data-hb-state`
   * perque el CSS en pugui decidir el color (poc estoc, taronja).
   */
  function noteFor(note, entry) {
    // Sense dades de la variant no se'n porta el compte de l'estoc: no s'avisa
    // de res (mateix criteri que el Liquid amb `inventory_management` buit).
    if (!entry) return { text: '', state: '' };

    // Esgotada: ho diu la pastilla de la talla, la nota sobra.
    if (entry.state === 'sold-out') return { text: '', state: '' };

    if (entry.state === 'low') {
      return {
        text: entry.restock
          ? note.getAttribute('data-note-low-restock')
          : note.getAttribute('data-note-low'),
        state: 'low',
      };
    }

    return { text: '', state: '' };
  }

  /**
   * Pinta la nota de la variant `id`; sense `id`, la de la talla SELECCIONADA.
   * El primer cas es el del ratoli per sobre d'una talla (veure mes avall).
   */
  function update(picker, id) {
    var note = picker.querySelector('[data-hb-note]');
    if (!note) return;

    var data = readStockData(picker);
    if (!data) return;

    if (!id) id = selectedVariantId(picker);
    var next = noteFor(note, id ? data[id] : null);

    if (note.textContent === next.text) return;

    note.textContent = next.text;

    if (next.state) {
      note.setAttribute('data-hb-state', next.state);
    } else {
      note.removeAttribute('data-hb-state');
    }
  }

  function updateAll() {
    var pickers = document.querySelectorAll('variant-picker');
    for (var i = 0; i < pickers.length; i++) update(pickers[i]);
  }

  document.addEventListener('change', function (event) {
    if (!event.target.closest) return;
    var picker = event.target.closest('variant-picker');
    if (picker) update(picker);
  });

  // RATOLI per sobre d'una talla: la nota de la talla que s'assenyala, encara
  // que no estigui triada. En sortir-ne, torna la de la seleccionada.
  //
  // La variant es la que el Liquid posa a cada input (`data-variant-id`): la
  // d'aquella talla amb la resta d'opcions tal com estan triades ara.
  //
  // `mouseover`/`mouseout` i no `mouseenter`: aquells burbullegen i un sol
  // escoltador al document serveix tambe quan el tema reemplaça el selector.
  function hoveredInput(event) {
    var label = event.target.closest && event.target.closest('.option-selector label.opt-label--btn');
    if (!label || !label.htmlFor) return null;
    var input = document.getElementById(label.htmlFor);
    return input && input.hasAttribute('data-variant-id') ? input : null;
  }

  document.addEventListener('mouseover', function (event) {
    var input = hoveredInput(event);
    if (!input) return;
    var picker = input.closest('variant-picker');
    if (picker) update(picker, input.getAttribute('data-variant-id'));
  });

  document.addEventListener('mouseout', function (event) {
    var input = hoveredInput(event);
    if (!input) return;
    // Encara dins de la mateixa etiqueta (d'un fill a l'altre): res a fer.
    if (event.relatedTarget && event.target.closest('label').contains(event.relatedTarget)) return;
    var picker = input.closest('variant-picker');
    if (picker) update(picker);
  });

  // El tema reemplaça el HTML del selector en canviar de variant i emet aquest
  // event un cop fet. La `<legend>` hi torna buida, aixi que cal reomplir-la.
  document.addEventListener('on:variant:change', updateAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }
})();
